import React from "react";
import hero1 from "../assets/hol2.jpg";
import hero2 from "../assets/hol4.jpg";
import hero3 from "../assets/hol5.jpg";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const CourseCat = () => {
  return (
    <div className="flex justify-center items-center md:px-0 px-4">
      <div className="md:w-10/12">
        <h2
          data-aos-duration="1500"
          data-aos="slide-right"
          className="text-2xl font-bold mb-10 font-serif"
        >
          Our Course Category
        </h2>
        <div className="grid grid-cols-1 gap-16 md:grid-cols-3">
          {/* Map over courses array */}
          {courses.map((course, index) => (
            <Link
              to={course.path}
              data-aos="fade-up"
              data-aos-easing="linear"
              data-aos-duration="1500"
              key={index}
              className="relative overflow-hidden bg-cover bg-no-repeat"
            >
              <img
                src={course.image.src}
                alt={course.image.alt}
                className="h-80 w-full object-cover rounded-lg transition duration-700 ease-in-out hover:scale-110"
              />
              <div
                className="bg-white bg-opacity-80 p-4 absolute bottom-0 left-0 right-0
                transition duration-300 ease-in-out"
                style={{ backgroundColor: "rgba(255, 255, 255, 0.8)" }}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-lg font-semibold">{course.title}</h3>
                    <p className="text-sm text-primary-350 line-clamp-1">
                      {course.description}
                    </p>
                  </div>
                  <button
                    className="text-gray-700 hover:text-gray-900 transition duration-300 ease-in-out"
                    onClick={() => {
                      // Handle button click event
                      console.log(`Clicked on ${course.title}`);
                    }}
                  >
                    <FaArrowRight className="ml-2" />
                  </button>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CourseCat;

const courses = [
  {
    title: "Diploma In Pharmacy",
    description:
      "The Diploma in Pharmacy (D. Pharm) program at Holy Vision Technical Campus (HVTC) provides students with a solid foundation in pharmaceutical sciences, focusing on practical training and theoretical knowledge essential for pharmacy practice.",
    image: {
      src: hero1,
      alt: "City 1",
    },
    path: "/pharmacy",
  },
  {
    title: "PCL In General Medicine (HA)",
    description:
      "The PCL in General Medicine (HA) at Holy Vision Technical Campus (HVTC) offers a comprehensive curriculum emphasizing practical skills and theoretical knowledge in healthcare. With state-of-the-art facilities and experienced faculty",
    image: {
      src: hero2,
      alt: "City 2",
    },
    path: "/ha",
  },
  {
    title: "PCL In Nursing",
    description: "Description for Course ",
    image: {
      src: hero3,
      alt: "City 3",
    },
    path: "/", // Placeholder path; adjust as needed
  },
];
